<template>
  <van-popup v-model="showpPopup" :overlay-style="{ background: 'rgba(0,0,0,.7)' }">
    <div class="receive-success">
      <img src="@/static/images/activityCenter/202403/withdrawal-success.png" />
      <div class="btn-content" @click="showpPopup = false"></div>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      showpPopup: false
    };
  },

  methods: {
    open() {
      this.showpPopup = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  background: transparent !important;
}
.receive-success {
  position: relative;
  img {
    width: 750px;
  }
  .btn-content {
    position: absolute;
    width: 280px;
    height: 70px;
    bottom: 352px;
    left: 50%;
    margin-left: -140px;
    display: flex;
    justify-content: space-between;
  }
}
/deep/.van-popup__close-icon--bottom-right {
  border: 1px solid #f5f6f9;
  border-radius: 50%;
}
/deep/.van-popup__close-icon--bottom-right {
  font-size: 50px;
  bottom: 0px;
  margin-right: 315px;
}
/deep/.van-popup__close-icon {
  color: #f5f6f9;
}
</style>
